import { makeAxiosRequest } from 'utils/apiMethods';

interface CollectionApi {
  fetchCollections: (data: any) => Promise<any>;
  fetchCollectionBySlug: any;
  fetchDefaultCollection: any;
}

const collectionApi: CollectionApi = {
  fetchCollections: makeAxiosRequest(`${process.env.REACT_APP_API_URL}/collections/`, {
    method: 'get',
  }),
  fetchDefaultCollection: makeAxiosRequest(
    `${process.env.REACT_APP_API_URL}/collections/org-default`,
    {
      method: 'get',
    },
  ),
  fetchCollectionBySlug: (slug: string) =>
    makeAxiosRequest(`${process.env.REACT_APP_API_URL}/collections/${slug}`, {
      method: 'get',
    }),
};

export default collectionApi;
